import "../styles.css";

const TitleLoader = () => {
  return <div className="title-loader-container"></div>;
};

export default TitleLoader;
